import React, { useEffect, useState } from 'react';
import DoneDrinkCard from '../components/DoneDrinkCard';
import DoneFoodCard from '../components/DoneFoodCard';
import Header from '../components/Header';

function DoneRecipes() {
  const [doneRecipes, setDoneRecipes] = useState([]);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    if (doneRecipes.length !== 0) {
      if (filter === 'all') {
        setDoneRecipes(JSON.parse(localStorage.getItem('doneRecipes')) || []);
      } else {
        setDoneRecipes(JSON.parse(localStorage.getItem('doneRecipes'))
          .filter((recipe) => (recipe.type === filter)) || []);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  useEffect(() => {
    setDoneRecipes(JSON.parse(localStorage.getItem('doneRecipes')) || []);
  }, []);

  return (
    <div className="done-favorite">
      <Header Title="Done Recipes" />
      <div className="fav-buttons">
        <button
          data-testid="filter-by-all-btn"
          type="button"
          onClick={ () => setFilter('all') }
          className="f-buttons"
        >
          All
        </button>
        <button
          data-testid="filter-by-food-btn"
          type="button"
          onClick={ () => setFilter('food') }
          className="f-buttons"
        >
          Food
        </button>
        <button
          data-testid="filter-by-drink-btn"
          type="button"
          onClick={ () => setFilter('drink') }
          className="f-buttons"
        >
          Drinks
        </button>
      </div>
      <div className="f-recipes">
        {
          doneRecipes.length !== 0 ? (
            doneRecipes.map((recipe, index) => (
              recipe.type === 'food' ? (
                <DoneFoodCard
                  key={ index }
                  recipe={ recipe }
                  index={ index }
                />
              ) : (
                <DoneDrinkCard
                  key={ index }
                  recipe={ recipe }
                  index={ index }
                />
              )
            ))
          ) : <p className="noRecipe">Sem receitas :(</p>
        }
      </div>
    </div>
  );
}

export default DoneRecipes;
